import { render, staticRenderFns } from "./CouponEmpty.vue?vue&type=template&id=2858a154&"
import script from "./CouponEmpty.vue?vue&type=script&lang=js&"
export * from "./CouponEmpty.vue?vue&type=script&lang=js&"
import style0 from "./CouponEmpty.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports